import { TextField } from '@mui/material';

import styled from '@emotion/styled';

import { colors } from 'styles/globalStyles';

export const StyledTextField = styled(TextField)(({ error }) => {
  return {
    '&': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      borderRadius: '4px',
      position: 'relative',
      padding: '6px 4px 6px 0',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
      cursor: 'pointer',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-root ': {
      cursor: 'pointer',
      paddingLeft: '10px',
      border: '1px solid',
      borderColor: error ? colors.red : colors.borderGrey,
      '&:focus': {
        borderColor: colors.focusBlue,
        borderRadius: '4px',
        backgroundColor: colors.white,
      },
    },
    '& .MuiButtonBase-root': {
      padding: 0,
      marginLeft: '2px',
    },
  };
});

export const StyledContainer = styled('div')({
  width: '100%',
  '& .MuiFormLabel-root.Mui-error ': {
    whiteSpace: 'initial',
    minWidth: '100%',
  },
});
